import { PayloadAction } from "@reduxjs/toolkit";
import {
  ICompareDocsItems,
  IOPDBillMappingFetchResp,
  IOPDBillsState,
  IOPDErrorResp,
  IOPDHealthCareBillHeaderFetchResp,
  IOPDSchemeBillPackageItem,
  IOPDSchemeHeaderFetchResp,
  ISchemeMappingsInHealthCare,
} from "../interfaces/IOPDBills";
import { ADD_OPD_BILL_WIZARD_ITEMS } from "./constants";
import { extractFileType } from "./globalUtils";
import { errorMessage, successMessage } from "./notificationUtils";

const updateSchemeDataUtil = (
  state: IOPDBillsState,
  action: PayloadAction<IOPDSchemeHeaderFetchResp | IOPDErrorResp>
) => {
  if (action.payload.response) {
    const schemeHeaderId = action.payload.response?.schemeOpdBillHeader?.id;
    const billMappingOpdId =
      action.payload.response?.schemeOpdBillHeader?.billMappingId;

    if (schemeHeaderId && action.payload.response?.schemeOpdBillHeader) {
      try {
        if (state.addOPDBill.currState.currSchemeBillHeaderId) {
          const documentUrl =
            action.payload.response?.schemeOpdBillHeader.billPathScheme || "";
          const documentUrlPatientPayable =
            action.payload.response?.schemeOpdBillHeader
              .billPathPatientPayable || "";
          const documentUrlReferralLetter =
            action.payload.response?.schemeOpdBillHeader.s3DocReferralLetter ||
            "";
          // const documentUrlDischargeSummary =
          //   action.payload.response?.schemeOpdBillHeader.s3DocDischargeSummary ||
          //   "";
          const documentUrlOthers =
            action.payload.response?.schemeOpdBillHeader.s3DocOthers || "";

          const documentUrlDocVariation =
            action.payload.response?.schemeOpdBillHeader
              .billPathVariationStatement || "";

          const uniqueUrl = documentUrl
            ? `${documentUrl}?timestamp=${new Date().getTime()}`
            : "";
          const uniqueUrlPatientPayable = documentUrlPatientPayable
            ? `${documentUrlPatientPayable}?timestamp=${new Date().getTime()}`
            : "";
          const uniqueUrlReferralLetter = documentUrlReferralLetter
            ? `${documentUrlReferralLetter}?timestamp=${new Date().getTime()}`
            : "";
          // const uniqueUrlDischargeSummary = `${documentUrlDischargeSummary}?timestamp=${new Date().getTime()}`;
          const uniqueUrlDocumentUrlOthers = documentUrlOthers
            ? `${documentUrlOthers}?timestamp=${new Date().getTime()}`
            : "";
          const uniqueUrlDocumentDocVariation = documentUrlDocVariation
            ? `${documentUrlDocVariation}?timestamp=${new Date().getTime()}`
            : "";

          const docVariation: ICompareDocsItems = {
            type: extractFileType(
              action.payload.response?.schemeOpdBillHeader
                .billPathVariationStatement || ""
            ),
            item:
              // action.payload.response?.schemeOpdBillHeader
              //   .billPathVariationStatement || "",
              uniqueUrlDocumentDocVariation,
            isUploaded: true,
            fileObj: null,
          };
          const docCGHSBill: ICompareDocsItems = {
            type: extractFileType(
              action.payload.response?.schemeOpdBillHeader.billPathScheme || ""
            ),
            item: uniqueUrl,
            isUploaded: true,
            fileObj: null,
          };
          const docPatientPayable: ICompareDocsItems = {
            type: extractFileType(
              action.payload.response?.schemeOpdBillHeader
                .billPathPatientPayable || ""
            ),
            item:
              // action.payload.response?.schemeOpdBillHeader
              //   .billPathPatientPayable || "",
              uniqueUrlPatientPayable,
            isUploaded: true,
            fileObj: null,
          };
          const docReferralLetter: ICompareDocsItems = {
            type: extractFileType(
              action.payload.response?.schemeOpdBillHeader
                .s3DocReferralLetter || ""
            ),
            item:
              // action.payload.response?.schemeOpdBillHeader
              //   .s3DocReferralLetter || "",
              uniqueUrlReferralLetter,
            isUploaded: action.payload.response?.schemeOpdBillHeader
              ? true
              : false,
            fileObj: null,
          };
          // const docDischargeSumary: ICompareDocsItems = {
          //   type: extractFileType(
          //     action.payload.response?.schemeOpdBillHeader
          //       .s3DocDischargeSummary || ""
          //   ),
          //   item:
          //     action.payload.response?.schemeOpdBillHeader
          //       .s3DocDischargeSummary || "",
          //   isUploaded: action.payload.response?.schemeOpdBillHeader
          //     .s3DocDischargeSummary
          //     ? true
          //     : false,
          //   fileObj: null,
          // };
          const docOthers: ICompareDocsItems = {
            type: extractFileType(
              action.payload.response?.schemeOpdBillHeader.s3DocOthers || ""
            ),
            item:
              // action.payload.response?.schemeOpdBillHeader.s3DocOthers || "",
              uniqueUrlDocumentUrlOthers,
            isUploaded: action.payload.response?.schemeOpdBillHeader.s3DocOthers
              ? true
              : false,
            fileObj: null,
          };

          state.addOPDBill.relatedDocs[
            state.addOPDBill.currState.currSchemeBillHeaderId
          ] = {
            ["VARIATION"]: docVariation,
            ["CGHS BILL"]: docCGHSBill,
            ["PATIENT PAYABLE"]: docPatientPayable,
            // ["DISCHARGE SUMMARY"]: docDischargeSumary,
            ["REFERRAL LETTER"]: docReferralLetter,
            ["OTHER"]: docOthers,
          };

          if (billMappingOpdId) {
            state.addOPDBill.finalScreen.billMappingMap[
              billMappingOpdId
            ].billMapping.billDateTime =
              action.payload.response?.schemeOpdBillHeader?.billDateTime;
          }
        }
      } catch (error) {
        console.error("Can't update related docs in store");
      }

      // Populate cghs.opd
      const cghsOPDBillItems: {
        [key: string]: Array<number>;
      } = {};

      action.payload.response?.schemeOpdBillItems?.schemeOpdBillOpdItems?.forEach(
        (opdItem) => {
          state.addOPDBill.finalScreen.allSchemeBillItems.cghs.opd[opdItem.id] =
            opdItem;
          if (!cghsOPDBillItems.hasOwnProperty(opdItem.serviceCategory)) {
            cghsOPDBillItems[opdItem.serviceCategory] = [opdItem.id];
          } else {
            cghsOPDBillItems[opdItem.serviceCategory].push(opdItem.id);
          }

          // Update the mappings in health care bill items
          const schemeMapping: ISchemeMappingsInHealthCare = {
            itemMappingInSchemeCategory: "cghs",
            itemMappingInSchemeSubCategory: "opd",
            itemMappingInSchemeServiceCategory: opdItem.serviceCategory,
            itemMappingInSchemeId: opdItem.id,
          };
          opdItem.lid?.forEach((id) => {
            if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd[
                id
              ].schemeMappings = [];
            } else if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical[
                id
              ].schemeMappings = [];
            }
          });
          opdItem.lid?.forEach((id) => {
            if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd[
                id
              ].schemeMappings.push(schemeMapping);
            } else if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical[
                id
              ].schemeMappings.push(schemeMapping);
            }
          });
        }
      );

      // Populate cghs.implant
      const cghsImplantBillItems: {
        [key: string]: Array<number>;
      } = {};
      action.payload.response?.schemeOpdBillItems?.schemeOpdBillImplantItems?.forEach(
        (opdItem) => {
          state.addOPDBill.finalScreen.allSchemeBillItems.cghs.implant[
            opdItem.id
          ] = opdItem;
          if (!cghsImplantBillItems.hasOwnProperty(opdItem.serviceCategory)) {
            cghsImplantBillItems[opdItem.serviceCategory] = [opdItem.id];
          } else {
            cghsImplantBillItems[opdItem.serviceCategory].push(opdItem.id);
          }

          // Update the mappings in health care bill items
          const schemeMapping: ISchemeMappingsInHealthCare = {
            itemMappingInSchemeCategory: "cghs",
            itemMappingInSchemeSubCategory: "implant",
            itemMappingInSchemeServiceCategory: opdItem.serviceCategory,
            itemMappingInSchemeId: opdItem.id,
          };

          opdItem.lid?.forEach((id) => {
            if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd[
                id
              ].schemeMappings = [];
            } else if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical[
                id
              ].schemeMappings = [];
            }
          });

          opdItem.lid?.forEach((id) => {
            if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd[
                id
              ].schemeMappings.push(schemeMapping);
            } else if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical[
                id
              ].schemeMappings.push(schemeMapping);
            }
          });
        }
      );

      // Populate cghs.package
      const cghsPackageBillItems: {
        [key: string]: Array<number>;
      } = {};
      action.payload.response?.schemeOpdBillItems?.schemeOpdBillPackageItems?.forEach(
        (opdItem) => {
          state.addOPDBill.finalScreen.allSchemeBillItems.cghs.package[
            opdItem.id
          ] = opdItem;
          if (!cghsPackageBillItems.hasOwnProperty(opdItem.serviceCategory)) {
            cghsPackageBillItems[opdItem.serviceCategory] = [opdItem.id];
          } else {
            cghsPackageBillItems[opdItem.serviceCategory].push(opdItem.id);
          }

          const schemeMapping: ISchemeMappingsInHealthCare = {
            itemMappingInSchemeCategory: "cghs",
            itemMappingInSchemeSubCategory: "package",
            itemMappingInSchemeServiceCategory: opdItem.serviceCategory,
            itemMappingInSchemeId: opdItem.id,
          };

          opdItem.lid?.forEach((id) => {
            if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd[
                id
              ].schemeMappings = [];
            } else if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical[
                id
              ].schemeMappings = [];
            }
          });

          // Update the mappings in health care bill items
          opdItem.lid?.forEach((id) => {
            if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd[
                id
              ].schemeMappings.push(schemeMapping);
            } else if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical[
                id
              ].schemeMappings.push(schemeMapping);
            }
          });
        }
      );

      // Populate cghs.medical
      const cghsMedicalBillItems: {
        [key: string]: Array<number>;
      } = {};
      action.payload.response?.schemeOpdBillItems?.schemeOpdBillMedicalItems?.forEach(
        (opdItem) => {
          state.addOPDBill.finalScreen.allSchemeBillItems.cghs.medical[
            opdItem.id
          ] = opdItem;
          if (!cghsMedicalBillItems.hasOwnProperty(opdItem.serviceCategory)) {
            cghsMedicalBillItems[opdItem.serviceCategory] = [opdItem.id];
          } else {
            cghsMedicalBillItems[opdItem.serviceCategory].push(opdItem.id);
          }

          // Update the mappings in health care bill items
          const schemeMapping: ISchemeMappingsInHealthCare = {
            itemMappingInSchemeCategory: "cghs",
            itemMappingInSchemeSubCategory: "medical",
            itemMappingInSchemeServiceCategory: opdItem.serviceCategory,
            itemMappingInSchemeId: opdItem.id,
          };
          opdItem.lid?.forEach((id) => {
            if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd[
                id
              ].schemeMappings = [];
            } else if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical[
                id
              ].schemeMappings = [];
            }
          });
          opdItem.lid?.forEach((id) => {
            if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd[
                id
              ].schemeMappings.push(schemeMapping);
            } else if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical[
                id
              ].schemeMappings.push(schemeMapping);
            }
          });
        }
      );

      // Populate patientPayable.opd
      const patientPayableOPDBillItems: {
        [key: string]: Array<number>;
      } = {};
      action.payload.response?.schemeOpdBillItems?.schemeOpdBillOpdItemsPatientPayable?.forEach(
        (opdItem) => {
          state.addOPDBill.finalScreen.allSchemeBillItems.patientPayable.opd[
            opdItem.id
          ] = opdItem;
          if (
            !patientPayableOPDBillItems.hasOwnProperty(opdItem.serviceCategory)
          ) {
            patientPayableOPDBillItems[opdItem.serviceCategory] = [opdItem.id];
          } else {
            patientPayableOPDBillItems[opdItem.serviceCategory].push(
              opdItem.id
            );
          }

          // Update the mappings in health care bill items
          const schemeMapping: ISchemeMappingsInHealthCare = {
            itemMappingInSchemeCategory: "patientPayable",
            itemMappingInSchemeSubCategory: "opd",
            itemMappingInSchemeServiceCategory: opdItem.serviceCategory,
            itemMappingInSchemeId: opdItem.id,
          };
          opdItem.lid?.forEach((id) => {
            if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd[
                id
              ].schemeMappings = [];
            } else if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical[
                id
              ].schemeMappings = [];
            }
          });
          opdItem.lid?.forEach((id) => {
            if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd[
                id
              ].schemeMappings.push(schemeMapping);
            } else if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical[
                id
              ].schemeMappings.push(schemeMapping);
            }
          });
        }
      );

      // Populate patientPayable.medical
      const patientPayableMedicalBillItems: {
        [key: string]: Array<number>;
      } = {};
      action.payload.response?.schemeOpdBillItems?.schemeOpdBillMedicalItemsPatientPayable?.forEach(
        (opdItem) => {
          state.addOPDBill.finalScreen.allSchemeBillItems.patientPayable.medical[
            opdItem.id
          ] = opdItem;
          if (
            !patientPayableMedicalBillItems.hasOwnProperty(
              opdItem.serviceCategory
            )
          ) {
            patientPayableMedicalBillItems[opdItem.serviceCategory] = [
              opdItem.id,
            ];
          } else {
            patientPayableMedicalBillItems[opdItem.serviceCategory].push(
              opdItem.id
            );
          }

          // Update the mappings in health care bill items
          const schemeMapping: ISchemeMappingsInHealthCare = {
            itemMappingInSchemeCategory: "patientPayable",
            itemMappingInSchemeSubCategory: "medical",
            itemMappingInSchemeServiceCategory: opdItem.serviceCategory,
            itemMappingInSchemeId: opdItem.id,
          };
          opdItem.lid?.forEach((id: number) => {
            if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd[
                id
              ].schemeMappings = [];
            } else if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical[
                id
              ].schemeMappings = [];
            }
          });
          opdItem.lid?.forEach((id: number) => {
            if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.opd[
                id
              ].schemeMappings.push(schemeMapping);
            } else if (
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical.hasOwnProperty(
                id
              )
            ) {
              state.addOPDBill.finalScreen.allHealthCareBillItems.medical[
                id
              ].schemeMappings.push(schemeMapping);
            }
          });
        }
      );

      state.addOPDBill.finalScreen.schemeBillHeaderIdDataMap[schemeHeaderId] = {
        billHeader: action.payload.response?.schemeOpdBillHeader,
        billItems: {
          cghs: {
            opd: cghsOPDBillItems,
            implant: cghsImplantBillItems,
            medical: cghsMedicalBillItems,
            package: cghsPackageBillItems,
          },
          patientPayable: {
            opd: patientPayableOPDBillItems,
            medical: patientPayableMedicalBillItems,
          },
        },
      };
    }
  }
};

const updateOPDBillMappingsUtil = (
  state: IOPDBillsState,
  action: PayloadAction<IOPDBillMappingFetchResp | IOPDErrorResp>,
  editFlow: boolean
) => {
  const { response } = action.payload;
  if (response) {
    state.addOPDBill.currState.currBillMappingId = response?.billMappingOpd?.id;

    state.addOPDBill.currState.currHealthCareBillHeaderId =
      response?.billMappingOpd.healthCareOpdBillHeaderId;

    // Set healthCareBillIdDataMap to null
    state.addOPDBill.finalScreen.healthCareBillIdDataMap[
      response?.billMappingOpd.healthCareOpdBillHeaderId
    ] = {
      billHeader: null,
      billItems: {
        opd: {},
        medical: {},
      },
      patientPayableData: null,
    };

    // Set schemeBillHeaderIdToSchemeBillHeaderDataMap to null
    state.addOPDBill.finalScreen.schemeBillHeaderIdDataMap[
      response?.billMappingOpd?.schemeOpdBillHeaderId
    ] = {
      billHeader: null,
      billItems: {
        cghs: {
          implant: {},
          opd: {},
          package: {},
          medical: {},
        },
        patientPayable: {
          opd: {},
          medical: {},
        },
      },
    };

    state.addOPDBill.currState.currSchemeBillHeaderId =
      response?.billMappingOpd?.schemeOpdBillHeaderId;
    state.addOPDBill.currState.claimId = response?.billMappingOpd?.claimId;

    state.addOPDBill.finalScreen.billMappingMap[response?.billMappingOpd?.id] =
      {
        billMapping: response?.billMappingOpd,
        documentPaths: response?.documentPaths,
      };

    if (editFlow) {
      state.addOPDBill.currState.claimId =
        response?.billMappingOpd.claimId?.toString();
      // For edit flow update local files variable from response
      response?.documentPaths?.forEach((doc) => {
        state.addOPDBill.localFiles[doc.documentType] = {
          ...doc,
          originFileObj: {},
          caseId: "",
          hospitalId: "",
          patientId: "",
          uid: doc.s3DocumentId,
          name: doc.documentName,
          url: doc.documentUrl,
        };
        state.addOPDBill.localFiles2.push({
          ...doc,
          originFileObj: {}, // Initialize empty object for the file object
          caseId: "",
          hospitalId: "",
          patientId: "",
          uid: doc.s3DocumentId,
          name: doc.documentName,
          url: doc.documentUrl,
        });
      });

      // For edit flow in wizard canNavigate and complete should be true
      state.addOPDBill.allWizardSteps?.forEach((step) => {
        step.completed = true;
        step.canNavigate = true;
      });

      // For edit flow the flow should directly land on final screen
      state.addOPDBill.currState.wizardCurrScreen =
        state.addOPDBill.allWizardSteps.length - 1;
    }
  }
};

const resetOPDBillStateUtil = (state: IOPDBillsState) => {
  state.isFetchingBillList = false;
  state.pageToOPDBillList = {};
  state.opdListFilters = {
    searchTerm: "",
    orderBy: "DESC",
    pageNumber: 1,
    pageSize: 10,
    startDate: null,
    endDate: null,
  };
  state.opdBillListCurrState = {
    totalElements: 0,
  };
  state.addOPDBill = {
    filters: {
      searchFiltersByComponents: {
        scheme: {
          cghs: {
            opd: "",
            implant: "",
            package: "",
            medical: "",
          },
          patientPayable: {
            opd: "",
            medical: "",
          },
        },
        healthCare: {
          opd: "",
          medical: "",
        },
      },
    },
    localFiles: {},
    localFiles2: [],
    allWizardSteps: ADD_OPD_BILL_WIZARD_ITEMS,

    opdManualQuestions: {
      opdQuestionnaires: {},
      isFetchingQuestionnaires: false,
      currentQuestionId: 1,
      answeredQuestionsResponse: {
        cardCategory: "",
        conclusion: "",
        healthCareBillItemsResponses: {
          healthCareBillOpdItems: [],
          healthCareBillMedicalItems: [],
        },
        packageDates: [],
        questionAnswersCollectedResponses: [],
        tataMemorialRateApply: "",
      },
      isConclusionGenerated: false,
    },
    finalScreen: {
      healthCareBillIdDataMap: {},
      schemeBillHeaderIdDataMap: {},
      billMappingMap: {},
      allHealthCareBillItems: {
        opd: {},
        medical: {},
      },
      allSchemeBillItems: {
        cghs: {
          implant: {},
          opd: {},
          package: {},
          medical: {},
        },
        patientPayable: {
          opd: {},
          medical: {},
        },
      },
    },
    billMappings: null,
    errors: {
      errorBillMapping: null,
      errorHealthCareBillHeader: null,
      errorHealthCarePatientPayable: null,
      errorQuestionAnswerCollection: null,
      errorBillSchemeHeader: null,
      errorPostQuestionAnswerCollection: null,
      errorInUpdatingSchemeBillItems: null,
      errorInApprovingOPDBill: null,
    },
    loaders: {
      isSchemeBillItemsUpdating: false,
      isFetchOPDBillData: false,
      isApprovingOPDBill: false,
      isResetData: false,
    },
    currState: {
      currBillMappingId: null,
      currSchemeBillHeaderId: null,
      currHealthCareBillHeaderId: null,
      wizardCurrScreen: 0,
      claimId: null,
      arePackagedItemsHighlighted: false,
      arePatientPayableItemsHighlighted: false,
    },
    relatedDocs: {},
  };
};

const remove1to1OPDSchemeBillItemUtil = (
  state: IOPDBillsState,
  lidList: Array<number>
) => {};

const updateSchemePackageUtil = (
  state: IOPDBillsState,
  action: PayloadAction<{ packages: Array<IOPDSchemeBillPackageItem> }>
) => {
  try {
    const { packages } = action.payload;
    if (
      state.addOPDBill.currState.currSchemeBillHeaderId !== null &&
      packages.length > 0
    ) {
      packages?.forEach((packageItem) => {
        state.addOPDBill.finalScreen.allSchemeBillItems.cghs.package[
          packageItem.id
        ] = packageItem;

        const schemeMapping: ISchemeMappingsInHealthCare = {
          itemMappingInSchemeCategory: "cghs",
          itemMappingInSchemeSubCategory: "package",
          itemMappingInSchemeServiceCategory: packageItem.serviceCategory,
          itemMappingInSchemeId: packageItem.id,
        };

        packageItem.lid?.forEach((lid) => {
          //check if item is present in healthcare opd
          if (
            state.addOPDBill.finalScreen.allHealthCareBillItems.opd.hasOwnProperty(
              lid
            )
          ) {
            state.addOPDBill.finalScreen.allHealthCareBillItems.opd[
              lid
            ].schemeMappings = [
              ...state.addOPDBill.finalScreen.allHealthCareBillItems.opd[lid]
                .schemeMappings,
              schemeMapping,
            ];
          } else if (
            state.addOPDBill.finalScreen.allHealthCareBillItems.medical.hasOwnProperty(
              lid
            )
          ) {
            state.addOPDBill.finalScreen.allHealthCareBillItems.medical[
              lid
            ].schemeMappings = [
              ...state.addOPDBill.finalScreen.allHealthCareBillItems.medical[
                lid
              ].schemeMappings,
              schemeMapping,
            ];
          }
        });
      });

      if (
        state.addOPDBill.finalScreen.schemeBillHeaderIdDataMap[
          state.addOPDBill.currState.currSchemeBillHeaderId
        ].billItems.cghs.package.hasOwnProperty("PACKAGE") &&
        state.addOPDBill.finalScreen.schemeBillHeaderIdDataMap[
          state.addOPDBill.currState.currSchemeBillHeaderId
        ].billItems.cghs.package["PACKAGE"]
      ) {
        state.addOPDBill.finalScreen.schemeBillHeaderIdDataMap[
          state.addOPDBill.currState.currSchemeBillHeaderId
        ].billItems.cghs.package["PACKAGE"] = [
          ...state.addOPDBill.finalScreen.schemeBillHeaderIdDataMap[
            state.addOPDBill.currState.currSchemeBillHeaderId
          ].billItems.cghs.package["PACKAGE"],
          ...packages?.map((packageItem) => {
            return packageItem.id;
          }),
        ];
      } else {
        state.addOPDBill.finalScreen.schemeBillHeaderIdDataMap[
          state.addOPDBill.currState.currSchemeBillHeaderId
        ].billItems.cghs.package["PACKAGE"] = [
          ...packages?.map((packageItem) => {
            return packageItem.id;
          }),
        ];
      }
    }
    successMessage("Package added successfully");
  } catch (error) {
    errorMessage("Error in adding package");
    console.error(error);
  }
};

const fetchNewOPDHealthCareBillHeaderUtil = (
  state: IOPDBillsState,
  action: PayloadAction<IOPDHealthCareBillHeaderFetchResp | IOPDErrorResp>
) => {
  try {
    if (
      action.payload.response?.healthCareOpdBillItems?.healthCareOpdBillOpdItems
        .length === 0 &&
      action.payload.response?.healthCareOpdBillItems
        ?.healthCareOpdBillMedicalItems.length === 0
    ) {
      errorMessage("Not able to process the bill. Please try again.", 6);
      return;
    }

    const healthCareBillHeaderId =
      action.payload.response?.healthCareOpdBillHeader.id;

    const headerData = action.payload.response?.healthCareOpdBillHeader;

    const healthCareBillItems = action.payload.response?.healthCareOpdBillItems;

    if (healthCareBillHeaderId && headerData && healthCareBillItems) {
      const tempHealthCareOPDBillItemsMap: {
        [key: string]: Array<number>;
      } = {};

      healthCareBillItems.healthCareOpdBillOpdItems?.forEach((opdItem) => {
        // fill all healthcare bill items map
        state.addOPDBill.finalScreen.allHealthCareBillItems.opd[opdItem.id] = {
          ...opdItem,
          schemeMappings: [],
        };

        // Populate Health Care OPD Bill Items Map
        if (
          !tempHealthCareOPDBillItemsMap.hasOwnProperty(opdItem.serviceCategory)
        ) {
          tempHealthCareOPDBillItemsMap[`${opdItem.serviceCategory}`] = [
            opdItem.id,
          ];
        } else {
          tempHealthCareOPDBillItemsMap[`${opdItem.serviceCategory}`].push(
            opdItem.id
          );
        }
      });

      const tempHealthCareMedicalBillItemsMap: {
        [key: string]: Array<number>;
      } = {};
      healthCareBillItems.healthCareOpdBillMedicalItems?.forEach(
        (medicalItem) => {
          // fill all healthcare bill items map
          state.addOPDBill.finalScreen.allHealthCareBillItems.medical[
            medicalItem.id
          ] = {
            ...medicalItem,
            schemeMappings: [],
          };

          // Populate Health Care Medical Bill Items Map
          if (
            !tempHealthCareMedicalBillItemsMap.hasOwnProperty(
              medicalItem.serviceCategory
            )
          ) {
            tempHealthCareMedicalBillItemsMap[
              `${medicalItem.serviceCategory}`
            ] = [medicalItem.id];
          } else {
            tempHealthCareMedicalBillItemsMap[
              `${medicalItem.serviceCategory}`
            ].push(medicalItem.id);
          }
        }
      );

      state.addOPDBill.finalScreen.healthCareBillIdDataMap[
        healthCareBillHeaderId
      ] = {
        ...state.addOPDBill.finalScreen.healthCareBillIdDataMap[
          healthCareBillHeaderId
        ],
        billHeader: headerData,
        billItems: {
          opd: tempHealthCareOPDBillItemsMap,
          medical: tempHealthCareMedicalBillItemsMap,
        },
      };
    }
  } catch (error) {
    state.addOPDBill.errors.errorHealthCareBillHeader =
      "Cannot fetch health care bill headers";
  } finally {
    state.addOPDBill.loaders.isFetchOPDBillData = false;
  }
};

export {
  updateSchemeDataUtil,
  updateOPDBillMappingsUtil,
  resetOPDBillStateUtil,
  remove1to1OPDSchemeBillItemUtil,
  updateSchemePackageUtil,
  fetchNewOPDHealthCareBillHeaderUtil,
};
